var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26634 1.01359L0.451094 5.82747C0.182969 6.09697 0.182969 6.53147 0.451094 6.80097L5.25617 11.606C5.39092 11.7394 5.56692 11.8068 5.74292 11.8068C5.91892 11.8068 6.09492 11.7394 6.22967 11.606C6.49779 11.3365 6.49779 10.902 6.22967 10.6325L2.59747 7H15.3753C15.7548 7 16.0628 6.692 16.0628 6.3125C16.0628 5.933 15.7548 5.625 15.3753 5.625H2.60022L6.23847 1.98572C6.50659 1.71759 6.50659 1.28172 6.23847 1.01359C5.97034 0.745469 5.53447 0.745469 5.26634 1.01359Z",
    fill: "#E81111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrowLeft);
export default __webpack_public_path__ + "static/media/RedArrowLeft.9df8f46279e30a6d45c2924381511ebc.svg";
export { ForwardRef as ReactComponent };